import { render } from "./AdminTestAnalytics.vue?vue&type=template&id=8c84457a&scoped=true"
import script from "./AdminTestAnalytics.vue?vue&type=script&lang=js"
export * from "./AdminTestAnalytics.vue?vue&type=script&lang=js"

import "./AdminTestAnalytics.vue?vue&type=style&index=0&id=8c84457a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c84457a"]])

export default __exports__